import React, { useMemo } from "react";
import HistoryRow from "./HistoryRow";
import { filterConversations, groupConversations } from "./groupConversations";

const PAGE = 30;

// Search, New chat, the grouped list, "Show more" and the privacy note.
export default function HistoryList({ conversations, loading, currentId, query, onQueryChange, visibleCount, onShowMore, onSelect, onNewChat, onDelete }) {
  const filtered = useMemo(() => filterConversations(conversations, query), [conversations, query]);
  const shown = filtered.slice(0, visibleCount);
  const groups = useMemo(() => groupConversations(shown), [shown]);
  const searching = String(query || "").trim().length > 0;

  return (
    <div className="hl">
      <div className="hl-tools">
        <input
          className="hl-search"
          type="search"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search your chats"
          aria-label="Search your chats"
          autoComplete="off"
        />
        <button type="button" className="hl-new" onClick={onNewChat}>
          New chat
        </button>
      </div>

      <div className="hl-list">
        {loading && conversations.length === 0 && <p className="hl-empty">Loading your chats...</p>}

        {!loading && conversations.length === 0 && (
          <div className="hl-empty-state">
            <h3>No chats yet.</h3>
            <p>Say hello to Rigby and your conversations will show up here.</p>
            <button type="button" className="hl-new hl-new--inline" onClick={onNewChat}>
              Start a chat
            </button>
          </div>
        )}

        {conversations.length > 0 && filtered.length === 0 && searching && (
          <p className="hl-empty">No chats match "{query.trim()}".</p>
        )}

        {groups.map((g) => (
          <section key={g.label} aria-label={g.label}>
            <h3 className="hl-group">{g.label}</h3>
            {g.items.map((c) => (
              <HistoryRow key={c.id} conversation={c} active={c.id === currentId} onSelect={onSelect} onDelete={onDelete} />
            ))}
          </section>
        ))}

        {filtered.length > shown.length && (
          <button type="button" className="hl-more" onClick={onShowMore}>
            Show more ({shown.length} of {filtered.length})
          </button>
        )}
      </div>

      <p className="hl-private">
        <strong>Private to you.</strong> Only you can see your chats. Deleting a chat removes it for good.
      </p>
    </div>
  );
}

export { PAGE };
